import { useOnlyLocale } from '@adsk/alloy-react-locale';

const useIs12Hour = ({
  is12HourOverride,
}: {
  is12HourOverride: boolean | undefined;
}): boolean => {
  const { locale } = useOnlyLocale();

  if (is12HourOverride !== undefined) {
    return is12HourOverride;
  }

  const dateTimeFormat = Intl.DateTimeFormat(locale, {
    hour: 'numeric',
  });

  const detectedIs12Hour = dateTimeFormat.resolvedOptions().hour12;

  if (detectedIs12Hour !== undefined) {
    return detectedIs12Hour;
  }

  /**
   * Backup for locales which do not list "hour12"
   * https://stackoverflow.com/a/60437579
   */
  const formatParts = dateTimeFormat.formatToParts(new Date(2020, 0, 1, 13)); // 1:00pm or 13:00
  if (formatParts.find((part) => part.type === 'hour')?.value.length === 2) {
    return true;
  }

  return false;
};

export default useIs12Hour;
